import { G2S } from '../g2s';

export class UtilsService {
    getAffiliateInfo(partnerCookie: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/InternalTools/GetAffiliateInfo',
                    {
                        partnerCookie: partnerCookie
                    })
                .then(function (response) {
                    resolve(<string>response.data.affiliateText);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
